const LmsFormField = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  required = true,
  autoComplete,
  placeholder,
}) => (
  <label className="lms-field">
    <span>{label}</span>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      autoComplete={autoComplete}
      placeholder={placeholder}
    />
  </label>
);

export default LmsFormField;
